import React from 'react'
import classnames from 'classnames/bind'
import styles from './Avatar.module.css'
import { getInitials } from '@/react/front/utils/formatters'

const cx = classnames.bind(styles)

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg'

export interface AvatarProps {
  firstName?: string
  lastName?: string
  src?: string
  size?: AvatarSize
  className?: string
}

const Avatar: React.FC<AvatarProps> = ({
  firstName,
  lastName,
  src,
  size = 'md',
  className
}) => {
  const initials = getInitials(firstName, lastName)

  return (
    <span className={cx('avatar', size, className)} aria-hidden="true">
      {src
        ? (
          <img src={src} alt="" className={styles.image} />
          )
        : (
            initials
          )}
    </span>
  )
}

export default Avatar
